// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"140":"5db333cc4ec44fb527f7","679":"7d6ec9c6d7344d10462d","874":"562fadf49aacabbcb0ac"}[chunkId] + ".css";
};